export default __webpack_public_path__ + "39a0ba1b156fb1760966e6a650d40e07.svg";